import React, { ChangeEvent, KeyboardEvent, useState } from "react";
import { useMediaQuery } from "react-responsive";

interface MessageInputFieldProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onAttachClick?: () => void;
  onSendClick?: () => void;
}

const MessageInputField: React.FC<MessageInputFieldProps> = ({
  value,
  onChange,
  onAttachClick,
  onSendClick,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 640px)" });

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    // On desktop, allow Shift+Enter for a new line
    if (!isMobile && e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // Prevent default new line behavior
      if (onSendClick) {
        onSendClick();
      }
    }
  };

  return (
    <div className="relative w-full">
      <textarea
        className="w-full text-text-base text-[14px] rounded-lg border border-border-subtle px-[8px] py-[10px] pr-24 focus:outline-none resize-none"
        placeholder="Enter message here"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        rows={1}
        style={{ overflow: "hidden" }}
      />
      <div className="absolute right-[48px] top-1/2 transform -translate-y-1/2 h-[30px] w-[1px] bg-border-subtle"></div>

      {/* Send Icon */}
      <button
        type="button"
        onClick={onSendClick}
        className="absolute right-3 top-[55%] transform -translate-y-1/2"
      >
        <span
          className="material-symbols-outlined text-icon-base"
          style={{ fontSize: "20px" }}
        >
          send
        </span>
      </button>
    </div>
  );
};

export default MessageInputField;
